/**
 * Created by weslei on 3/26/17.
 */

import React, { Component } from "react";

class Header extends Component {
  render() {
    return (
<span></span>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.js